import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { DateField } from '../components/Table/fields/DateField';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPDateField } from '../components/Table/fields/SPDateField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { CustomFieldForAccommodationCategoryCosts } from '../components/Table/fields/CustomFieldForAccommodationCategoryCosts';

export const accommodationCategoryCost: SchemaWithClient<any> = {
  name: 'Accommodation Category Cost',
  pluralName: 'Accommodation Category Cost',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    sales_partner: {
      name: 'Sales Partner',
      fieldRenderer: SelectField.tableAdapter(enumItems.salesPartner),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.salesPartner
      ),
      multiSwitchboard: true,
      url: enumItems.salesPartner.client.getAllPath,
      tempSchema: enumItems.salesPartner,
    },
    accommodation_category: {
      name: 'Accommodation Category',
      fieldRenderer: SelectField.tableAdapter(enumItems.accommodationCategory),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.accommodationCategory
      ),
      switchboard: true,
      url: enumItems.accommodationCategory.client.getAllPath,
      tempSchema: enumItems.accommodationCategory,
    },
    valid_from: {
      name: 'Valid From',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    valid_to: {
      name: 'Valid to',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    booking_from: {
      name: 'Booking Valid From',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    booking_to: {
      name: 'Booking Valid to',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    costs: {
      name: 'PP Costs',
      fieldRenderer: CustomFieldForAccommodationCategoryCosts,
      slidePaneFieldRenderer: CustomFieldForAccommodationCategoryCosts,
      fieldType: 'custom',
    },
    group_price: {
      name: 'Group Price',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },
    currency: {
      name: 'Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.currency),
      switchboard: true,
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/accommodation-category-costs'),
};
